module.exports = __webpack_public_path__ + "img/zk-icon-store-set.684b0fe7.svg";